<template>
  <div class="h-100">
    <div style="height: calc(100% - 58px);
    overflow-y: scroll;">

      <div class="col-12">
        <div class="row">

          <card id="labs-card">
            <div slot="header">
              <div class="row">
                <div class="col-10">
                  <h4 slot="header" class="card-title">
                    {{ $t("message.Preferred Lab Details") }}
                  </h4>
                </div>
                <div class="col-2 text-right pt-2" v-if="LAB_DETAILS_ENTERED">
                  <i class="fa fa-edit fa-2x text-muted" style="font-weight: 100" @click="resetLabDetails()"></i>
                </div>
              </div>
            </div>

            <!-- disabled location search to improve and implement later -->
            <!-- Location search -->
            <!-- <div v-if="!LOCATION_DETAILS_ENTERED && !LAB_DETAILS_ENTERED" class=" mt-2" @click="clearLocationSearchText">
              <fg-input :placeholder="$t('message.Search for city or locality')" type="text" v-model="locationSearchText" @keyup="searchLocation()" :addon-right-icon="
                          !locationSearchText
                            ? 'now-ui-icons ui-1_zoom-bold'
                            : 'now-ui-icons ui-1_simple-remove'
                        "></fg-input>
            </div>

            <div class="col-12 text-center" v-if="!LOCATION_DETAILS_ENTERED && !LAB_DETAILS_ENTERED">
              {{ $t('message.OR')}}
            </div> -->

            <!-- Lab search -->
            <div v-if="!LOCATION_DETAILS_ENTERED && !LAB_DETAILS_ENTERED" class=" mt-2" @click="clearLabSearchText">
              <fg-input :placeholder="$t('message.Search for lab facility')" :addon-right-icon="!labSearchText
                ? 'now-ui-icons ui-1_zoom-bold'
                : 'now-ui-icons ui-1_simple-remove'
                " type="text" v-model="labSearchText" @keyup="searchLab()"></fg-input>
            </div>

            <div v-if="searchedLabs" class="col-md-12" style="margin: 0px">
              <div v-for="lab in searchedLabs" :key="lab._id">
                <card @click.native="selectLab(lab)">
                  <div class="col-md-12">
                    {{ lab.name }}
                  </div>
                  <div class="col-md-12" v-if="lab.location && lab.location.addressDetails">
                    {{ lab.location.addressDetails.address }}
                  </div>
                </card>
              </div>
            </div>

            <div class="col-12 text-center" v-if="LOCATION_DETAILS_ENTERED">
              <div class="col-md-12" v-if="preferredLocation">
                <p style="font-weight:bold;">{{ preferredLocation.name }}</p>
                <p v-if="preferredLocation.location && preferredLocation.location.addressDetails">
                  {{ preferredLocation.location.addressDetails.address }}
                </p>
              </div>

              <check-mark-svg v-if="LOCATION_DETAILS_ENTERED"></check-mark-svg>
            </div>

            <div class="col-12 text-center" v-if="LAB_DETAILS_ENTERED">
              <div class="col-md-12" v-if="selectedLab">
                <p style="font-weight:bold;">{{ selectedLab.name }}</p>
                <p v-if="selectedLab.location && selectedLab.location.addressDetails">
                  {{ selectedLab.location.addressDetails.address }}
                </p>
              </div>

              <check-mark-svg v-if="LAB_DETAILS_ENTERED"></check-mark-svg>
            </div>

          </card>
        </div>
      </div>

      <!-- Lab Tests -->
      <!-- <div class="col-12">
      <div class="row">
        <card id="labs-card">
          <div slot="header">
            <div class="row">
              <div class="col-10">
                <h4 slot="header" class="card-title">
                  {{ $t("message.Lab Tests") }}
                </h4>
              </div>
            </div>
          </div>
          <textarea class="form-control" :placeholder="$t('message.Enter required lab tests')" rows="3" v-model="labTests"></textarea>
        </card>
      </div>
    </div> -->

      <!-- Preffered Date Range -->
      <div class="col-12" style="margin-top: 1em">
        <div class="row">
          <card id="preffered-date-card">
            <div slot="header">
              <div class="row">
                <div class="col-10">
                  <h4 slot="header" class="card-title">
                    {{ $t("message.Preferred Date") }}
                  </h4>
                </div>
              </div>
            </div>

            <div class="d-flex">
              <div class="pr-1">
                <el-date-picker v-model="preferredDateRange.from" format="dd-MM-yyyy" type="date" :picker-options="preferedDatePickerOptions" :placeholder="$t('message.From')" :editable="false"></el-date-picker>
              </div>
              <div class="pl-1">
                <el-date-picker v-model="preferredDateRange.to" format="dd-MM-yyyy" type="date" :picker-options="preferedDatePickerOptions" :placeholder="$t('message.To')" :editable="false"></el-date-picker>
              </div>
            </div>

            <!-- <div class="col-md-12 pt-2 pb-2">
              <n-checkbox v-model="healthCheckupRequest.sampleCollectionHome">{{
              $t("message.Sample colection at home")
            }}</n-checkbox>
            </div> -->

            <div class="col-12 text-center" v-if="preferredDateRange.from && preferredDateRange.to">
              <check-mark-svg></check-mark-svg>
            </div>
          </card>
        </div>
      </div>

      <!-- Health Package -->
      <!-- added a margin because health package and checkup button were overlaping -->
      <div class="col-12" style="margin-top: 1em; margin-bottom: 50px;">
        <div class="row">
          <card id="healthPacakge-card">
            <div slot="header">
              <div class="row">
                <div class="col-10">
                  <h4 slot="header" class="card-title">
                    {{ $t("message.Health Package") }}
                  </h4>
                </div>
              </div>
            </div>
            <div id="health-package-selector">
              <drop-down class="w-100" tag="div" direction="up" :title="(healthCheckupRequest &&
                healthCheckupRequest.healthPackage) ? healthCheckupRequest.healthPackage.name : $t('message.Select health package')">
                <div class="row mx-2 my-3" v-for="healthPackage in healthPackages" :key="healthPackage._id" @click="selectHealthPackage(healthPackage)">
                  <div class="col-9"><span>{{ healthPackage.name }}</span></div>
                  <div class="col-3 text-right"><span v-if="healthPackage.billingDetails.amount">₹ {{ healthPackage.billingDetails.amount }}</span><span v-if="!healthPackage.billingDetails.amount">--</span></div>
                </div>
              </drop-down>
            </div>
            <div class="col-12 text-center" v-if="healthCheckupRequest && healthCheckupRequest.healthPackage">
              <check-mark-svg></check-mark-svg>
            </div>
          </card>
        </div>
      </div>

      <!-- <modal :show.sync="modals.notice" footer-classes="justify-content-center" type="notice" v-if="healthCheckupRequest.healthPackage" :show-close="false">
      <h5 slot="header" class="modal-title">
        {{ healthCheckupRequest.healthPackage.name }}
      </h5>
      <template>
        <div class="instruction">
          <div class="row" style="height: 36em; overflow-y: scroll">
            <div class="col-6" v-for="testGroup in healthCheckupRequest.healthPackage.testGroups" :key="testGroup.group">
              <strong>{{ testGroup.group }}</strong>
              <ul style="padding-left: 1.5em">
                <li v-for="test in testGroup.tests" :key="test">{{ test }}</li>
              </ul>
            </div>
          </div>
        </div>
      </template>
      <div slot="footer" class="justify-content-center">
        <n-button type="info" round @click.native="modals.notice = false">{{
          $t("message.OK!")
        }}</n-button>
      </div>
    </modal> -->
    </div>
    <div style="position: absolute; bottom: 0px; width: 100%">
      <div class="col-12 text-center">
        <n-button type="primary" round @click.native="requestCheckup()">
          <i class="now-ui-icons ui-1_simple-add"></i>
          {{ $t("message.Request for Checkup") }}
        </n-button>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import socket from "@/services/socket";
// import veeValidate from "vee-validate";
import { Modal } from "src/components";

export default {
  name: "request-ahc",

  components: {
    Modal,
  },

  data() {
    return {
      locations: [
        {
          Location: "Mexico City",
          HospitalsOrLabs: [
            {
              name: "CliniMed - Unidad Polanco",
              contact: "+52 55 5531 3575",
              address:
                "Eugenio Sue 355, Polanco, Granada, Miguel Hidalgo, 11550 Ciudad de México, CDMX, Mexico",
              location: "https://g.page/Clinimedpolanco?share",
            },
            {
              name: "CliniMed - Centro Médico de Primer Contacto y Urgencias Básicas",
              contact: "+52 55 5531 3575",
              address:
                "Eugenio Sue 355, Polanco, Granada, Miguel Hidalgo, 11560 Ciudad de México, CDMX, Mexico",
              location: "https://goo.gl/maps/G3A6H4i5u6tpEqbRA",
            },
          ],
        },
        {
          Location: "Monterrey",
          HospitalsOrLabs: [
            {
              name: "Hospital Monterrey 2004",
              contact: "+52 81 8354 1191",
              address:
                "Calle Pablo A. de La Garza 1822, Martínez, 64550 Monterrey, N.L., Mexico",
              location: "https://goo.gl/maps/62tPd88v4T46n7DP9",
            },
          ],
        },
        {
          Location: "Guadalajara",
          HospitalsOrLabs: [
            {
              name: "Hospital México Americano",
              contact: "+52 33 3648 3333",
              address:
                "Calle Colomos No.2110, Ayuntamiento, 44620 Guadalajara, Jal., Mexico",
              location: "https://goo.gl/maps/3EsP8DvCcGC4jaGa9",
            },
          ],
        },
      ],
      healthCheckupRequest: {
        preferredDateRange: {},
      },
      preferredDateRange: {},
      preferredLocationValue: null,
      preferredLocation: null,
      preferredLab: null,
      preferedDatePickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() <
            moment().hours(0).minutes(0).seconds(0).milliseconds(0)
          );
        },
      },
      // labTests: "",

      LAB_DETAILS_ENTERED: false,
      LOCATION_DETAILS_ENTERED: false,
      labSearchText: "",
      searchedLabs: [],
      searchedLocations: [],
      labsPagination: {
        totalPages: 0,
        pageNumber: 1,
      },

      locationSearchText: "",

      modals: {
        notice: false,
      },
      healthPackages: [],
    };
  },

  computed: {
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
    // healthPackages() {
    //   return this.$store.state.healthPackages;
    // },
  },

  async mounted() {
    if (this.user && this.user.caregroup) {
      let caregroup = await this.$store.dispatch(
        "getCaregroup",
        this.user.caregroup._id || this.user.caregroup
      );
      if (caregroup && caregroup.healthPackages) {
        this.healthPackages = caregroup.healthPackages;
      }
    }

    //Calculate patient age from date of birth
    // let ageDifMs = Date.now() - new Date(this.user.dob).getTime();
    // let ageDate = new Date(ageDifMs);
    // let patientAge = Math.abs(ageDate.getUTCFullYear() - 1970);
    // //Select a Health Package for the patient
    // this.healthCheckupRequest.healthPackage = this.healthPackages.filter(
    //   (healthPackage) => {
    //     return (
    //       healthPackage.type == "ahc" &&
    //       (healthPackage.forGender == "all" ||
    //         this.user.gender.toLowerCase() == healthPackage.forGender) &&
    //       patientAge >= healthPackage.fromAge &&
    //       patientAge <= healthPackage.toAge
    //     );
    //   }
    // )[0];
  },

  methods: {
    async requestCheckup() {
      let that = this;
      if (!this.healthCheckupRequest.preferredLab) {
        swal.fire({
          text: this.$t("message.Preferred lab is not selected!"),
          type: "info",
          timer: 4000,
        });
        return;
      }

      if (!this.preferredDateRange.from || !this.preferredDateRange.to) {
        swal.fire({
          text: this.$t("message.Preferred date is not selected!"),
          type: "info",
          timer: 4000,
        });
        return;
      }

      if (!this.healthCheckupRequest.healthPackage) {
        swal.fire({
          text: this.$t("message.Health package is not selected!"),
          type: "info",
          timer: 4000,
        });
        return;
      }

      if (this.user.caregroup) {
        try {
          this.healthCheckupRequest.preferredDateRange.from = new Date(
            this.preferredDateRange.from
          ).getTime();
          this.healthCheckupRequest.preferredDateRange.to = new Date(
            this.preferredDateRange.to
          ).getTime();

          this.healthCheckupRequest = Object.assign(this.healthCheckupRequest, {
            isHealthCheckup: true,
            patientDetails: {

              //Adding _id to indicate patient already exists
              _id: this.user._id,
              patientId: this.user.patientId,
              firstName: this.user.firstName,
              lastName: this.user.lastName,
              gender: this.user.gender,
              dob: this.user.dob,
              history: this.user.history,
              mobileNumber: this.user.mobileNumber,
            },
            status: [{ status: "Pending", timestamp: new Date().getTime() }],
            latestStatus: "Pending",
            createdBy: "patient",
            requestFor: "healthCheckup",
            endpoint: this.user.endpoint && this.user.endpoint.name,
            // labTests: this.labTests,
          });

          //Create healthCheckupRequest
          try {
            this.healthCheckupRequest = await this.$store.dispatch(
              "createHealthCheckupRequest",
              this.healthCheckupRequest
            );

            socket.emit("healthCheckupRequest", {
              caregroupId: this.user.caregroup._id || this.user.caregroup,
              healthCheckupRequestId: this.healthCheckupRequest._id,
            });

            swal
              .fire({
                title:
                  this.$t("message.Health Checkup") + " " + this.$t("message.Requested"),
                type: "success",
                timer: 3000,
                showCloseButton: true,
              })
              .then(() => {
                this.$store.commit("setState", {
                  stateName: "bookingReq",
                  stateValue: this.healthCheckupRequest,
                });
                this.$router.push("viewhealthcheckuprequest");

                // this.$router.push("ahc");
              });
          } catch (e) {
            console.log(e);

            let errorMessage = ''

            if (e && e.response && e.response.data && e.response.data.message) {
              errorMessage = e.response.data.message
            }

            swal.fire({
              type: 'error',
              title: this.$t('message.Oops!'),
              text: errorMessage,
              timer: 3000
            })
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        swal.fire({
          title: this.$t("message.Sorry") + "!",
          text:
            this.$t("message.Could not initiate the appointment Contact Administrator") +
            "\n" +
            this.$t("message.Error: Caregroup is not assigned the patient"),
          type: "warning",
          showCloseButton: true,
        });
      }
    },
    selectHealthPackage(hp) {
      this.healthCheckupRequest.healthPackage = hp;
      this.$forceUpdate();
    },
    getHealthPackageName() {
      if (
        this.healthCheckupRequest &&
        this.healthCheckupRequest.healthPackage
      ) {
        return this.healthCheckupRequest.healthPackage.name;
      } else {
        return this.$t("message.Select health package");
      }
    },
    clearLabSearchText(event) {
      if (event.target.classList.value.indexOf("ui-1_simple-remove") > -1) {
        this.labSearchText = "";
      }
    },
    clearLocationSearchText(event) {
      if (event.target.classList.value.indexOf("ui-1_simple-remove") > -1) {
        this.locationSearchText = "";
      }
    },
    async searchLab() {
      try {
        this.searchedLabs = [];
        if (this.labSearchText.length > 0) {
          let response = await this.$store.dispatch("getLabEndpoints", {
            pageNumber: this.labsPagination.pageNumber,
            searchStr: this.labSearchText,
          });
          this.searchedLabs = response.data;
          this.labsPagination.totalPages = response.totalPages;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async selectLab(lab) {
      this.LAB_DETAILS_ENTERED = true;
      this.healthCheckupRequest.preferredLab = lab.name;
      this.selectedLab = lab;
      this.labSearchText = "";
      this.searchedLabs = [];
    },
    resetLabDetails() {
      this.LAB_DETAILS_ENTERED = false;
      this.healthCheckupRequest.preferredLab = null;
      this.selectedLab = null;
      this.labSearchText = "";
    },
    async searchLocation() {
      try {
        this.searchedLocations = [];

        //Implement location search
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style scoped>
/deep/#health-package-selector .dropdown-menu {
  width: 100%;
}

/deep/#health-package {
  background-color: transparent;
}

/deep/#healthPacakge-card .dropdown-toggle {
  font-size: 1.2rem;
  padding-top: 0;
}

/deep/.form-group .el-input__inner[readonly] {
  background-color: transparent;
}

/deep/ textarea.form-control {
  border: 1px solid #e3e3e3;
  border-radius: 12px;
}
</style>
